import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Home, Search, Phone } from 'lucide-react';
import { Layout } from '@/components/layout';
import { Button } from '@/components/ui/button';
import SEO from '@/components/shared/SEO';

const NotFoundPage = () => {
  return (
    <Layout>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." noIndex />

      <section className="min-h-[70vh] flex items-center justify-center bg-muted py-16">
        <div className="container-portico">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-xl mx-auto text-center"
            data-testid="not-found-page"
          >
            {/* 404 Number */}
            <div className="relative mb-6">
              <span className="text-[8rem] md:text-[10rem] font-heading font-black text-primary/10 leading-none select-none">
                404
              </span>
            </div>

            {/* Content */}
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground -mt-12 mb-4">
              Page Not Found
            </h1>
            <p className="text-muted-foreground mb-8 max-w-md mx-auto">
              The page you're looking for may have been moved, removed, or doesn't exist. Let's get you back on track.
            </p>

            {/* Quick Links */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8">
              <Link to="/" data-testid="404-home-link">
                <div className="bg-card border border-border rounded-xl p-4 hover:border-primary/40 hover:shadow-md transition-all cursor-pointer">
                  <Home className="w-5 h-5 text-primary mx-auto mb-2" />
                  <span className="text-sm font-medium text-foreground">Home</span>
                </div>
              </Link>
              <Link to="/products" data-testid="404-products-link">
                <div className="bg-card border border-border rounded-xl p-4 hover:border-primary/40 hover:shadow-md transition-all cursor-pointer">
                  <Search className="w-5 h-5 text-primary mx-auto mb-2" />
                  <span className="text-sm font-medium text-foreground">Browse Products</span>
                </div>
              </Link>
              <Link to="/contact" data-testid="404-contact-link">
                <div className="bg-card border border-border rounded-xl p-4 hover:border-primary/40 hover:shadow-md transition-all cursor-pointer">
                  <Phone className="w-5 h-5 text-primary mx-auto mb-2" />
                  <span className="text-sm font-medium text-foreground">Contact Us</span>
                </div>
              </Link>
            </div>

            {/* Back Button */}
            <Button
              variant="outline"
              onClick={() => window.history.back()}
              data-testid="404-go-back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFoundPage;
